export default __webpack_public_path__ + "media/images/pagination-centre-271b1c5b73eb5cc75f4ac027a301729e.png";